import billLogApi from '@/api/billLog/billLogApi'

export default {
    name: 'bill-log-email-check',
    mixins: [],
    extends: {},
    components: {},
    props: ['toEmail', 'phListChosen', 'randomCode'],
    data() {
        return {
            verify: true,
            verifyCode: ''
        };
    },
    computed: {

    },
    watch: {},
    created() {

    },
    mounted() {

    },
    updated() {},
    beforeDestroy() {},
    methods: {

        async checkEMailVerifyCode() {
            let valid = await this.$validator.validate();
            if (valid) {
                // 整合payload物件
                const payload = {
                    toEmail: this.toEmail,
                    verifyCode: this.verifyCode,
                    randomCode: this.randomCode,
                    phListChosen: this.phListChosen
                }
                this.verify = await billLogApi.checkEMailVerifyCode(payload);
                // 比對結果錯誤, 前端顯示密碼錯誤
                if (this.verify) {
                    this.$router.push({name: 'bill-log-email-result'});
                }
            }
        }
    },
};


// WEBPACK FOOTER //
// ./src/components/billLog/billLogEMailCheck.js